Common.header = function () {
	/* Mobile navigation */
	$('.header-v1-menu-btn').click(() => $(document.body).toggleClass('header-nav-is-visible'))

	/* Navbar item destacado */
	const url = window.location.href;
	$('.header-v1-navigation-list a')
		.filter((i, el) => url.indexOf($(el).attr('href')) > -1)
		.first()
		.parent()
		.addClass('header-v1-navigation-item-highlight')
}
